import {LoadingPageSpinner} from '@aboutyou/ui-components';
import {lazy} from '@aboutyou/lazy-imports';
import React from 'react';

export const GiftCardRefundPage = lazy(
  () =>
    import('./GiftCardRefundPage.eager').then(mod => ({
      default: mod.GiftCardRefundPage,
    })),
  {
    fallback: <LoadingPageSpinner />,
    aboveTheFold: true,
  },
);
